import { useClose } from '@headlessui/react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { type SubmitHandler, useForm } from 'react-hook-form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Field, Fieldset } from '@/primitives/fieldset.tsx';
import type { OrganizationSearchParams } from '../types/organization-search-params.type.ts';

const KeywordLayoutSearch = () => {
  const { handleSubmit, register } = useForm<OrganizationSearchParams>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const close = useClose();

  const onSubmit: SubmitHandler<OrganizationSearchParams> = (value: OrganizationSearchParams) => {
    searchParams.set('keyword', value.keyword);
    navigate(`/organization?${searchParams.toString()}`);
    close();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Fieldset>
        <Field>
          <div>
            <div className='mt-2 flex'>
              <div className='-mr-px grid grow grid-cols-1 focus-within:relative'>
                <input
                  {...register('keyword')}
                  type='text'
                  placeholder='Search accounts...'
                  className='col-start-1 row-start-1 block w-full rounded-l-md bg-white py-1.5 pl-6 pr-3 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600 sm:pl-4 sm:text-sm/6'
                />
              </div>
              <button
                type='submit'
                className='flex shrink-0 items-center gap-x-1.5 rounded-r-md bg-primary-600 px-3 py-2 text-sm font-semibold text-white outline outline-1 -outline-offset-1 outline-gray-300 hover:bg-primary-300 focus:relative focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-secondary-600'
              >
                <MagnifyingGlassIcon aria-hidden='true' className='-ml-0.5 size-4 text-white' />
              </button>
            </div>
          </div>
        </Field>
      </Fieldset>
    </form>
  );
};

export default KeywordLayoutSearch;
